import React from "react";

export const NoInput = React.memo(({ children }) => {
  return children;
});
